import { module } from "../app";

module.directive("inputDropdown", function ($rootScope, $window, $animate) {
  return {
    restrict: "E",
    templateUrl: "views/templates/inputDropdown.html",
    scope: {
      list: "=",
      model: "=",
      disableenter: "=?",
      modelproperty: "@",
      property: "@",
      containerclass: "@",
    },
    require: '?ngModel',
    link: function (scope, element, ngModel) {
      scope.showDropdown = false;
      scope.selectedString = '';
      scope.onItemSelected = ($event, item) => {
        $event.preventDefault();
        $event.stopPropagation();
        const indexOfElement = scope.model[scope.modelproperty] && scope.model[scope.modelproperty].toLowerCase().indexOf(item[scope.property].toLowerCase());
        if (scope.model
          && scope.model[scope.modelproperty]
          && indexOfElement > -1) {
          const endIndex = indexOfElement + item[scope.property].length;
          let stringToRemove = scope.model[scope.modelproperty].substring(indexOfElement, endIndex);
          const firstComa = scope.model[scope.modelproperty].substring(0, endIndex).lastIndexOf(',');
          const indexOfComa = firstComa > -1 ? firstComa : scope.model[scope.modelproperty].substring(indexOfElement, scope.model[scope.modelproperty].length).indexOf(',');
          if (indexOfComa > -1){
            const stringBeforeComa = scope.model[scope.modelproperty].substring(0, indexOfComa);
            const stringAfterComa = scope.model[scope.modelproperty].substring(indexOfComa + 1, scope.model[scope.modelproperty].length);
            scope.model[scope.modelproperty] = stringBeforeComa + stringAfterComa.trim();
          }

          scope.model[scope.modelproperty] = scope.model[scope.modelproperty].trim().replace(stringToRemove, '').trim();
        }
        else {
          if (!scope.model){
            return;
          }

          if (!scope.model[scope.modelproperty] || scope.model[scope.modelproperty].length === 0){
            scope.model[scope.modelproperty] = item[scope.property];
            return;
          }

          const trimmedValue = scope.model[scope.modelproperty].trim();
          if (!trimmedValue || trimmedValue.length === 0) {
            scope.model[scope.modelproperty] = item[scope.property];
            return;
          }

          if (trimmedValue.lastIndexOf(',') === trimmedValue.length - 1){
            scope.model[scope.modelproperty] = `${trimmedValue} ${item[scope.property]}`;
            return;
          }

          scope.model[scope.modelproperty] = `${trimmedValue}, ${item[scope.property]}`;
        }
      };

      scope.$watch('model', function (newValue) {
        if (newValue[scope.modelproperty] === null || newValue[scope.modelproperty] === undefined) {
          return;
        }
        scope.selected = scope.list
          .filter(x => newValue[scope.modelproperty].toLowerCase().includes(x[scope.property].toLowerCase()));
        scope.selectedString = scope.selected
          .sort((a, b) => {
            const firstIndex = newValue[scope.modelproperty].indexOf(a[scope.property]);
            const secondeIndex = newValue[scope.modelproperty].indexOf(b[scope.property])
            if (firstIndex > secondeIndex){
              return 1;
            }

            if (firstIndex < secondeIndex){
              return -1;
            }

            return 0;
          })
          .map(x => x[scope.property])
          .join(', ');
      }, true);

      $(document).on('click', function (event) {
        const isClickedElementChildOfPopup = element
          .find(event.target)
          .length > 0;

        if (isClickedElementChildOfPopup)
          return;
        scope.showDropdown = false;
      });
    }
  };
});


// WEBPACK FOOTER //
// ./src/scripts/directives/inputDropdown.js